module.exports = __webpack_public_path__ + "static/img/105_TO8_1788_og.e7beb7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/105_TO8_1788_og.jpg
// module id = 93ZZ
// module chunks = 0